/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";

function getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsUrl(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/parcels` as const,
  };
  return res;
}

/**
 * @description Cria a parcela com Nosso Número gerado no banco do plano (com verificação de unicidade); 'multiple' gera cópias com +1 mês e +1 número cada, com serial próprio. Rejeita número de parcela duplicado (mesmo tipo, não cancelada). Migrado do legado IndividualPayment/CreateParcel POST. **(Requer Authorization para autenticação)**
 * @summary Cria parcela manual no plano (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels}
 */
export async function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
  data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >,
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsUrl(
      financialPersonId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
